import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";
import { normalizeEmail } from "@src/utils/string-utils";

export interface PatientSearchParams {
  user_uuid: unknown;
  first_name: unknown;
  last_name: unknown;
  dob: unknown;
  zipcode: unknown;
  email?: unknown;
  practice_id: unknown;
}

/**
 * Builds the callApi config for the patient-search endpoint.
 * Trims and conditionally includes the email field.
 */
export function buildPatientSearchConfig(params: PatientSearchParams): ApiCallConfig {
  const { user_uuid, first_name, last_name, dob, zipcode, email, practice_id } = params;

  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PATIENT_SEARCH,
    body: {
      user_uuid,
      first_name,
      last_name,
      dob,
      zipcode,
      ...(normalizeEmail(email) !== undefined ? { email: normalizeEmail(email) } : {}),
      practice_id,
    } as Record<string, unknown>,
  };
}
